export default __webpack_public_path__ + "static/media/backButton.126a3773.svg";